module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ct1",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#conp1",
      "id": "tocp1"
    }
  }, [_c('i', [_vm._v("Part 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "txd",
    attrs: {
      "id": "pz9-2"
    }
  }, [_c('i', [_vm._v("Love is the child of freedom, never that of domination.")])]), _vm._v(" "), _c('p', {
    staticClass: "txdr",
    attrs: {
      "id": "pz9-3"
    }
  }, [_vm._v("—E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RICH")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROMM ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879d56ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part01.vue
// module id = 75
// module chunks = 0